import { useContext } from 'react'
import { AxiosHeaders } from 'axios'
import { Languages } from '../../interfaces/common'
import { IResetUserPasswordByCallCodeData } from '../../interfaces/IResetUserPasswordByCallCodeData'
import { IResetUserPasswordByCallCodeParams } from '../../interfaces/IResetUserPasswordByCallCodeParams'
import { apiPost } from '../api'
import { RESET_PASSWORD_BY_CALL_CODE } from '../URLs'
import { useMutationHook } from './mutationHook'
import { GuestKeyContext } from '../../components/GuestKeyContext/GuestKeyContext'

export async function getCallCode(
  path: string,
  body: IResetUserPasswordByCallCodeParams,
  locale: Languages,
  guestKey: string,
) {
  const headers = new AxiosHeaders({ 'x-guest-key': guestKey })
  const { data } = await apiPost<IResetUserPasswordByCallCodeParams, IResetUserPasswordByCallCodeData>({
    path,
    body,
    locale,
    headers,
  })

  return data
}

export function useResetUserPasswordByCallCode() {
  const path = RESET_PASSWORD_BY_CALL_CODE
  const { guestKey } = useContext(GuestKeyContext)
  const mutationFn = (url: string, body: IResetUserPasswordByCallCodeParams, locale: Languages) =>
    getCallCode(url, body, locale, guestKey)
  const mutationFunc = useMutationHook({ path, mutationFn })

  return mutationFunc
}
